import { AuthorPage } from '@/app/pages/profile/author-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/author')({
  component: AuthorPage,
});
